<div
    class="container-fluid"
    [ngClass]="{ 'is-player-queue': isPlayerQueue }"
>
    <div class="row">
        <div class="col">
            <h2>{{ list?.name }}</h2>
        </div>
    </div>
    <div class="row">
        <div
            class="col-12"
            *ngFor="
                let i of !isPlayerQueue && !isExpanded
                    ? (list?.items || []).slice(0, 4)
                    : list?.items || []
            "
        >
            <ng-container
                *ngTemplateOutlet="itemTpl; context: { item: i }"
            ></ng-container>
        </div>
    </div>
    <div
        class="row"
        *ngIf="!isPlayerQueue && list?.items?.length > 4"
    >
        <div class="col">
            <button
                class="btn btn-link full-list"
                (click)="onToggleList($event)"
            >
                <span *ngIf="!isExpanded">{{
                    i18n._8501_VIEW_FULL_PLAYLIST
                        | translate: { items: list?.items?.length }
                }}</span>
                <span *ngIf="isExpanded">{{
                    i18n._8502_VIEW_LESS | translate
                }}</span>
            </button>
        </div>
    </div>
</div>

<ng-template
    #itemTpl
    let-item="item"
>
    <div class="item">
        <div aria-hidden="true">
            <a [routerLink]="['/', 'vimeo', 'video', item.playlistItemId]">
                <img
                    [src]="item.thumbnail"
                    alt
                    role="presentation"
                />
            </a>
        </div>
        <div>
            <div>
                <a
                    class="name"
                    [routerLink]="['/', 'vimeo', 'video', item.playlistItemId]"
                    >{{ item.name }}</a
                >
                <span
                    class="tag"
                    *ngIf="currentItem === item"
                    >{{ i18n._8503_NOW_PLAYING | translate }}</span
                >
                <span
                    class="tag"
                    *ngIf="item.lastWatched != null"
                    >{{ i18n._8504_WATCHED | translate }}</span
                >
                <div
                    class="description"
                    (click)="onItemDescClick($event)"
                >
                    {{ item.description }}
                </div>
            </div>
        </div>
    </div>
</ng-template>
